import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';
import { PosthogService } from './services/posthog.service';

@Component({
  selector: 'sp-root',
  standalone: true,
  imports: [RouterOutlet, Toast, ConfirmDialog],
  template: `
    <div class="app-container">
      <router-outlet></router-outlet>
      <p-toast></p-toast>
      <p-confirmDialog></p-confirmDialog>
    </div>
  `,
  styles: [
    `
      .app-container {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
      }
    `
  ]
})
export class AppComponent {
  title = 'arp-supplier-portal';
  constructor(private readonly posthogService: PosthogService) {}
}
